import { ScryerSpark } from "@scryerlabs/ui";

/**
 * Full-screen branded loading splash — the Scryer mark with a gentle breathing pulse.
 * Used for route/auth loading and while the CustomerProvisionGate resolves, so every
 * full-screen wait shares the same look.
 */
export function LoadingSpinner() {
  return (
    <div
      className="min-vh-100 d-flex flex-column align-items-center justify-content-center bg-body gap-3"
      role="status"
      aria-live="polite"
    >
      <ScryerSpark size={48} className="brand-spinner-mark" />
      <span className="text-body-secondary small">Loading…</span>
    </div>
  );
}
